import { render, staticRenderFns } from "./EntityMenu.vue?vue&type=template&id=128c27a2"
import script from "./EntityMenu.vue?vue&type=script&lang=js"
export * from "./EntityMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports